export function shouldUrlSkipScreenerModal({
  url,
}: {
  url: string | undefined;
}) {
  return (
    url?.includes('#') &&
    (url?.includes('#async-program-ppq') || url?.includes('#launch-ppq'))
  );
}
